import type {
  CalendarKind,
  CaseStatus,
  CourtDateKind,
  DeliveryMethod,
  LicenseStanding,
  NoticeKind,
  RenewalStatus,
  ViolationCategory,
  ViolationStatus,
} from '@myrentalmate/api-client';

type ChipColor = 'default' | 'success' | 'warning' | 'error' | 'info';

export const STANDING: Record<LicenseStanding, { label: string; color: ChipColor }> = {
  current: { label: 'Current', color: 'success' },
  expiring: { label: 'Expiring Soon', color: 'warning' },
  expired: { label: 'Expired', color: 'error' },
};

export const NOTICE_KIND: Record<NoticeKind, string> = {
  late: 'Late Rent',
  pay_or_quit: 'Pay or Quit',
  violation: 'Lease Violation',
  rent_increase: 'Rent Change',
  renewal: 'Renewal',
  general: 'General',
};

/** A rent change and a renewal start from their own pages. */
export const NEW_NOTICE_KINDS: NoticeKind[] = ['late', 'pay_or_quit', 'violation', 'general'];

export const DELIVERY: Record<DeliveryMethod, string> = {
  hand: 'By Hand',
  posted: 'Posted on the Door',
  certified_mail: 'Certified Mail',
  first_class_mail: 'First-Class Mail',
  other: 'Other',
};

export const VIOLATION_CATEGORY: Record<ViolationCategory, string> = {
  noise: 'Noise',
  pets: 'Pets',
  occupants: 'Unauthorized Occupants',
  damage: 'Property Damage',
  smoking: 'Smoking',
  parking: 'Parking',
  other: 'Other',
};

export const VIOLATION_STATUS: Record<ViolationStatus, { label: string; color: ChipColor }> = {
  open: { label: 'Open', color: 'warning' },
  cured: { label: 'Cured', color: 'success' },
  escalated: { label: 'Escalated', color: 'error' },
  closed: { label: 'Closed', color: 'default' },
};

export const CASE_STATUS: Record<CaseStatus, { label: string; color: ChipColor }> = {
  notice_served: { label: 'Notice Served', color: 'info' },
  filed: { label: 'Filed', color: 'info' },
  hearing_set: { label: 'Hearing Set', color: 'warning' },
  judgment: { label: 'Judgment', color: 'warning' },
  writ: { label: 'Writ', color: 'error' },
  closed: { label: 'Closed', color: 'default' },
};

export const COURT_KIND: Record<CourtDateKind, string> = {
  hearing: 'Hearing',
  trial: 'Trial',
  mediation: 'Mediation',
  other: 'Other',
};

export const RENEWAL_STATUS: Record<RenewalStatus, { label: string; color: ChipColor }> = {
  sent: { label: 'Waiting', color: 'info' },
  accepted: { label: 'Accepted', color: 'success' },
  declined: { label: 'Declined', color: 'error' },
  withdrawn: { label: 'Withdrawn', color: 'default' },
};

export const CALENDAR_KIND: Record<CalendarKind, { label: string; color: ChipColor }> = {
  court: { label: 'Court', color: 'error' },
  license: { label: 'License', color: 'warning' },
  lease_end: { label: 'Lease Ends', color: 'info' },
  cure: { label: 'Cure Date', color: 'warning' },
  notice: { label: 'Notice Deadline', color: 'warning' },
  renewal: { label: 'Renewal', color: 'info' },
  work_order: { label: 'Work Order', color: 'default' },
  insurance: { label: 'Insurance', color: 'warning' },
};
